import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { NavigationItemFragment } from '@productsite/src/graphql/generated/graphql-types'

/**
 * Pure function to compute category page metadata.
 * Can be used in both server components and client hooks.
 */
export function getCategoryPageMetadata(
  seoTitle: string | null,
  seoMetaDescription: string | null,
  categoryName: string,
  path: NavigationItemFragment[],
  translate: (key: string, params?: Record<string, string>) => string
) {
  const isTopCategory = path.length === 1

  const getFallbackMetaDescription = () => {
    return isTopCategory
      ? translate('Products_Metadescription_B2B')
      : translate('Category_MetaDescription_B2B',
          {
            category: categoryName,
          }
        )
  }

  const getFallbackTitle = () => {
    return isTopCategory
      ? translate('Products_Title_B2B')
      : path
          .slice(1)
          .reverse()
          .map(p => p.category?.seoLongTitleName ?? p.category?.name)
          .filter(Boolean)
          .join(' - ')
  }

  return {
    title: seoTitle ?? getFallbackTitle(),
    metaDescription: seoMetaDescription ?? getFallbackMetaDescription(),
  }
}

/**
 * Client hook wrapper around getCategoryPageMetadata.
 */
const useCategoryPageMetadata = (
  seoTitle: string | null,
  seoMetaDescription: string | null,
  categoryName: string,
  path: NavigationItemFragment[]
) => {
  const { translate } = useTranslations()
  return getCategoryPageMetadata(seoTitle, seoMetaDescription, categoryName, path, translate)
}

export default useCategoryPageMetadata
